var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcRight32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.488 29.179a1.667 1.667 0 0 1 0-2.357l10.488-10.489L10.488 5.845a1.667 1.667 0 1 1 2.357-2.357l11.667 11.667c.65.65.65 1.706 0 2.357L12.845 29.179c-.65.65-1.706.65-2.357 0",
  clipRule: "evenodd"
})));
export default SvgIcRight32;